export const WORDPRESS_API = process.env.REACT_APP_WORDPRESS_URL
export const WORDPRESS_API_JSON = process.env.REACT_APP_WORDPRESS_API_JSON
export const API_URL = process.env.REACT_APP_API_URL